import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HelpIcon from '@material-ui/icons/Help';
import { Link } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ParagraphTooltip } from 'Components/UI/ParagraphTooltip';

const styles = theme => ({
  root: {},
  calculatorListEntry: {
    display: 'flex',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.facet.border,
    padding: theme.spacing(1, 0),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  calculatorLink: {
    display: 'flex',
    fontSize: theme.typography.h3.fontSize,
  },
  calculatorTooltipPadding: {
    paddingTop: theme.spacing(2.5),
  },
  calculatorTooltip: {
    display: 'flex',
    cursor: 'pointer',
    fill: theme.palette.facet.accentBlue,
  },
});

const PlaybookToolDisplay = ({
  className,
  classes,
  toolsCollection,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {toolsCollection?.resources().list().map(resource => (
        <div
          className={classes.calculatorListEntry}
          key={resource.attr('name')}
        >
          <Link
            className={classes.calculatorLink}
            href={resource
              .relationship('externalLink')
              .link('related')
              .url()}
            target="_blank"
            rel="noopener noreferrer"
          >
            {resource.attr('name')}
          </Link>
          <ParagraphTooltip
            className={classes.calculatorTooltip}
            title={resource.attr('description')}
            placement="top-start"
          >
            <HelpIcon />
          </ParagraphTooltip>
        </div>
      ))}
    </div>
  );
};

PlaybookToolDisplay.defaultProps = {
  className: '',
};

PlaybookToolDisplay.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  toolsCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlaybookToolDisplay);
